import { render, staticRenderFns } from "./PublicTournamentRegister.vue?vue&type=template&id=0f129dfd&scoped=true"
import script from "./PublicTournamentRegister.vue?vue&type=script&lang=js"
export * from "./PublicTournamentRegister.vue?vue&type=script&lang=js"
import style0 from "./PublicTournamentRegister.vue?vue&type=style&index=0&id=0f129dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f129dfd",
  null
  
)

export default component.exports